import { ISetSubscriptionsFormatParams } from '../types/actionParams';
import { IEmptyResult } from '../types/IResponse';
import { Request } from './Request';

export class SetSubscriptionsFormatRequest extends Request<ISetSubscriptionsFormatParams, IEmptyResult> {
  constructor(params: ISetSubscriptionsFormatParams) {
    super('setSubscriptionsFormat', params);
  }
}
